import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'

function DashboardHomePage() {


  const apiUrl = process.env.REACT_APP_API_URL
  const seckey = process.env.REACT_APP_REV_KEY
  
  const [homeLoader, setHomeloader] = useState(null);

const [countGlazma , setCountGlazma] = useState(null)

  //geting glzma rev :::::::::::::::::::::::::::::::::::::::::::::::::::::


const getCountrev = async () => {
  setHomeloader(true); 
  try {
    const response = await fetch( `${apiUrl}/auth/dashboard-count-data-api`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json", 
        "seckey": seckey,
      },
    });

    const data = await response.json();

    console.log(data);

    if (response.ok) { 
     setCountGlazma(data)
    } else {
      toast.error(data.message || "Something went wrong");
    }
  } catch (error) {
    console.log("Error:", error);
    toast.error("Server is busy, please try again after some time");
  } finally {
    setHomeloader(false);
  }
};


useEffect(()=>{

  getCountrev()
},[])



  return (
    <div>

      <div className='dashboard-home-bg-cont'>
      <div className="dashboard-home-main">
      
      <div className="dashboard-home-rev-container-top-row">

<div className="dashboard-home-rev-container-top-cols">
  <p> { countGlazma && countGlazma.glazma}</p>
  <h6>Glazma</h6>
</div>
<div className="dashboard-home-rev-container-top-cols">
    <p>{ countGlazma && countGlazma.gocTotal}</p>
  <h6>GOC</h6>
</div>
<div className="dashboard-home-rev-container-top-cols">
    <p>{ countGlazma && countGlazma.FTcount}</p>
  <h6>fluffytouch</h6>
</div>

      </div>

      </div>
      </div>
    </div>
  )
}

export default DashboardHomePage